import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { FunctionComponent, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../../../store/Hooks';
import { SideMenu, SideMenuItem } from '@volvo/vcdk-react';
import { sideMenuConfig } from '../../MenuConfig';
import { selectMenuOpen } from '../../store/NavigationBarSlice';
import './NavigationSection.scss';

export const NavigationSection: FunctionComponent = () => {
	const { instance } = useMsal();
	const { t } = useTranslation('navigation');
	const menuOpen = useAppSelector(selectMenuOpen);
	const navigate = useNavigate();
	const { pathname } = useLocation();

	const account = instance.getActiveAccount();
	const isAuthenticated = useIsAuthenticated();

	const onSignOut = useCallback(() => {
		instance.logoutRedirect()
	}, [instance]);

	return (
		<SideMenu open={menuOpen} className="side-menu">
			{sideMenuConfig.filter(item => isAuthenticated || !item.authenticated)
				.map(item => (
					<SideMenuItem
						key={item.route}
						active={item.route === pathname}
						icon={item.icon}
						onClick={() => navigate(item.route)}>
						{t(item.label as unknown as TemplateStringsArray)}
					</SideMenuItem>
				))}
			{isAuthenticated &&
				<SideMenuItem icon="logout" onClick={onSignOut}>
					{t('menu.signout', { user: account?.name })}
				</SideMenuItem>
			}
		</SideMenu>
	);
};
